import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorBox } from '../../ErrorBox/ErrorBox'
import TrackedLinkCreateForm from './components/TrackedLinkCreateForm'
import TrackedLinksTable from './components/TrackedLinksTable'
import useTrackedLinks from './hooks/useTrackedLinks'
import { hideTrackedLinkCreateModal, showAnalyticsModal } from '../../../actions'
import styles from './TrackedLinkCreateModal.module.css'

const TrackedLinkCreateModal = () => {
  const dispatch = useDispatch()
  const site = useSelector((state) => state.modals.trackedModalPayload.site)
  const siteDomain = site.subdomain
  const email = useSelector((state) => state.manage.userProfile?.email) || site.email

  const {
    linkName,
    setLinkName,
    trackedLinks,
    isLoadingLinks,
    isCreatingLink,
    errorMessage,
    handleCreateLink,
    handleDeleteLink,
    handleRetry
  } = useTrackedLinks(siteDomain, email)

  const handleHide = () => {
    dispatch(hideTrackedLinkCreateModal())
  }

  return (
    <Modal show={true} onHide={handleHide} centered size="lg" className={styles.modal}>
      <Modal.Body className={`p-4 p-lg-5 bg-white rounded ${styles.modalContent}`}>
        <div className={styles.modalHeader}>
          <h4 className="mb-4 fw-bold">Create Share & Track Link</h4>
        </div>

        <div className={styles.modalBody}>
          {errorMessage ? (
            <ErrorBox className="pb-0" message={errorMessage} onClick={handleRetry} />
          ) : (
            <>
              <TrackedLinkCreateForm
                linkName={linkName}
                setLinkName={setLinkName}
                handleCreateLink={handleCreateLink}
                isCreatingLink={isCreatingLink}
                isLoadingLinks={isLoadingLinks}
                trackedLinksCount={trackedLinks.length}
              />

              <div className="mt-5">
                <h6 className="mb-3 fw-bold">Your tracked links ({trackedLinks.length}/20)</h6>
                <div className={styles.trackedLinksContainer}>
                  <TrackedLinksTable
                    trackedLinks={trackedLinks}
                    isLoadingLinks={isLoadingLinks}
                    onDelete={handleDeleteLink}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default TrackedLinkCreateModal
